import React from 'react';
import Loader from '@gr-monorepo/common/public/ui/Loader';
import { CloseCross } from 'assets/images/icons';
import {
  ErrorText,
  FileName,
  FilePlateBox,
  FilePlateCloseButton,
  FilePlateWrap,
} from './FilePlateStyled';

export type FilePlateProps = {
  files: {
    file: { name: string; size: number };
    isLoading?: boolean;
    loadingProgress?: number;
    isErrored?: boolean;
    operationId: number;
  }[];
  onRemove?: (index: number | null) => void;
  errors?: string[];
};

type FilePlateRowProps = {
  file: { name: string; size: number };
  isLoading?: boolean;
  isErrored?: boolean;
  operationId: number;
  onRemove?: (operationId: number) => void;
};

const FilePlateRow = ({ file, isLoading, isErrored, operationId, onRemove }: FilePlateRowProps) => {
  return (
    <FilePlateBox isError={isErrored} data-testid="file-plate-row">
      <FileName title={file.name}>{file.name}</FileName>
      {isLoading ? (
        <Loader size={20} />
      ) : (
        <FilePlateCloseButton type="button" aria-label="Удалить файл" onClick={() => onRemove?.(operationId)} data-testid="file-plate-remove-button">
          <CloseCross />
        </FilePlateCloseButton>
      )}
    </FilePlateBox>
  );
};

export const FilePlate = ({ files, onRemove, errors }: FilePlateProps) => {
  const errorMessages = errors?.map((error) => <ErrorText key={error}>{error}</ErrorText>);

  if (!files.length) {
    return null;
  }

  return (
    <>
      <FilePlateWrap data-testid="file-plate">
        {files.map((fileRecord) => (
          <FilePlateRow
            key={fileRecord.operationId}
            file={fileRecord.file}
            isLoading={fileRecord.isLoading}
            isErrored={fileRecord.isErrored}
            operationId={fileRecord.operationId}
            onRemove={(operationId) => onRemove?.(operationId)}
          />
        ))}
      </FilePlateWrap>
      {!!errorMessages?.length && errorMessages}
    </>
  );
};
